import type { Variants } from "framer-motion";

export const dropdownVariants: Variants = {
  hidden: {
    opacity: 0,
    y: -8,
    scale: 0.98,
    transitionEnd: { pointerEvents: "none" },
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transitionEnd: { pointerEvents: "auto" },
    transition: { type: "spring", stiffness: 320, damping: 26, mass: 0.7 },
  },
  exit: {
    opacity: 0,
    y: -8,
    scale: 0.98,
    transitionEnd: { pointerEvents: "none" },
    transition: { duration: 0.15 },
  },
};

/** iOS's page push curve: quick start, long soft landing. For pushed pages and sheets. */
export const IOS_PUSH = {
  type: "tween",
  ease: [0.32, 0.72, 0, 1],
  duration: 0.45,
} as const;
